/* eslint-disable */ import { AjvReflection, DomainEntityReflection, EnumReflection, RawAliasReflection } from '@salsita-ai/platform-project-sdk/domain';
export const modelVersion = 11;
export const WallType = new EnumReflection('WallType', {
    enum: [
        'A',
        'B',
        'C'
    ]
});
export const WallDirection = new EnumReflection('WallDirection', {
    enum: [
        'left',
        'right'
    ]
});
export const CornerFillerType = new EnumReflection('CornerFillerType', {
    enum: [
        'AB',
        'BC'
    ]
});
export const Handing = new EnumReflection('Handing', {
    enum: [
        'left',
        'right',
        'top',
        'both',
        'none'
    ]
});
export const RoomShapeType = new EnumReflection('RoomShapeType', {
    enum: [
        'L',
        'U',
        'I'
    ]
});
export const CabinetColor = new EnumReflection('CabinetColor', {
    type: 'string',
    enum: [
        'Obsidian',
        'Glacier',
        'PacificBlue',
        'CaliforniaPoppy',
        'Surf',
        'DesertSage',
        'Limestone',
        'Sierra'
    ]
});
export const FuelType = new EnumReflection('FuelType', {
    type: 'string',
    enum: [
        'None',
        'Propane',
        'NaturalGas'
    ]
});
export const GrillBaseVariant = new EnumReflection('GrillBaseVariant', {
    type: 'string',
    enum: [
        'Default',
        'WithWarmingDrawer'
    ]
});
export const BurnerBaseW24Variant = new EnumReflection('BurnerBaseW24Variant', {
    type: 'string',
    enum: [
        'CounterTopHeight',
        'Lowered'
    ]
});
export const LynxProfessionalGrillVariant = new EnumReflection('LynxProfessionalGrillVariant', {
    type: 'string',
    enum: [
        'RotisserieOnly',
        'AllTrident',
        'TridentAndRotisserie'
    ]
});
export const LynxSedonaGrillVariant = new EnumReflection('LynxSedonaGrillVariant', {
    type: 'string',
    enum: [
        'ProSear_SsBurner1',
        'ProSear_SsBurner1_Rotisserie',
        'SsBurner3',
        'ProSear_SsBurner2',
        'SsBurner3_Rotisserie',
        'ProSear_SsBurner2_Rotisserie'
    ]
});
export const PowderCoatType = new EnumReflection('PowderCoatType', {
    type: 'string',
    enum: [
        'Anvil',
        'Swatch',
        'Pulse'
    ]
});
export const WallSummaryItem = new AjvReflection('WallSummaryItem', {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'object',
                    properties: {
                        id: {
                            type: 'string'
                        },
                        comment: {
                            type: 'string'
                        },
                        message: {
                            type: 'string'
                        },
                        values: {
                            type: 'object',
                            additionalProperties: true
                        }
                    },
                    required: [
                        'id'
                    ],
                    additionalProperties: false
                }
            ]
        },
        sku: {
            type: 'string'
        },
        dealerPrice: {
            type: 'number'
        },
        retailPrice: {
            type: 'number'
        },
        currentUserPrice: {
            type: 'number'
        },
        thumbnailUrl: {
            type: 'string'
        },
        packageDepth: {
            type: 'number'
        },
        packageHeight: {
            type: 'number'
        },
        packageWidth: {
            type: 'number'
        },
        packageWeight: {
            type: 'number'
        },
        color: CabinetColor._meta.schema
    },
    required: [
        'id',
        'name',
        'sku',
        'dealerPrice',
        'retailPrice',
        'currentUserPrice',
        'packageDepth',
        'packageHeight',
        'packageWidth',
        'packageWeight'
    ],
    additionalProperties: false
});
export const WallSummary = new AjvReflection('WallSummary', {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'object',
                    properties: {
                        id: {
                            type: 'string'
                        },
                        comment: {
                            type: 'string'
                        },
                        message: {
                            type: 'string'
                        },
                        values: {
                            type: 'object',
                            additionalProperties: true
                        }
                    },
                    required: [
                        'id'
                    ],
                    additionalProperties: false
                }
            ]
        },
        cabinets: {
            type: 'array',
            items: WallSummaryItem._meta.schema
        },
        parts: {
            type: 'array',
            items: WallSummaryItem._meta.schema
        },
        appliances: {
            type: 'array',
            items: WallSummaryItem._meta.schema
        },
        dealerPrices: {
            type: 'object',
            properties: {
                appliances: {
                    type: 'number'
                },
                cabinetsAndParts: {
                    type: 'number'
                }
            },
            additionalProperties: false,
            required: [
                'appliances',
                'cabinetsAndParts'
            ]
        },
        retailPrices: {
            type: 'object',
            properties: {
                appliances: {
                    type: 'number'
                },
                cabinetsAndParts: {
                    type: 'number'
                }
            },
            additionalProperties: false,
            required: [
                'appliances',
                'cabinetsAndParts'
            ]
        },
        currentUserPrice: {
            type: 'object',
            properties: {
                appliances: {
                    type: 'number'
                },
                cabinetsAndParts: {
                    type: 'number'
                }
            },
            additionalProperties: false,
            required: [
                'appliances',
                'cabinetsAndParts'
            ]
        }
    },
    required: [
        'id',
        'name',
        'cabinets',
        'parts',
        'appliances',
        'dealerPrices',
        'retailPrices',
        'currentUserPrices'
    ],
    additionalProperties: false
});
export const Summary = new AjvReflection('Summary', {
    type: 'object',
    properties: {
        walls: {
            type: 'array',
            items: WallSummary._meta.schema
        },
        dealerPrices: {
            type: 'object',
            properties: {
                appliances: {
                    type: 'number'
                },
                cabinetsAndParts: {
                    type: 'number'
                }
            },
            additionalProperties: false,
            required: [
                'appliances',
                'cabinetsAndParts'
            ]
        },
        retailPrices: {
            type: 'object',
            properties: {
                appliances: {
                    type: 'number'
                },
                cabinetsAndParts: {
                    type: 'number'
                }
            },
            additionalProperties: false,
            required: [
                'appliances',
                'cabinetsAndParts'
            ]
        },
        currentUserPrices: {
            type: 'object',
            properties: {
                appliances: {
                    type: 'number'
                },
                cabinetsAndParts: {
                    type: 'number'
                }
            },
            additionalProperties: false,
            required: [
                'appliances',
                'cabinetsAndParts'
            ]
        }
    },
    required: [
        'walls',
        'dealerPrices',
        'retailPrices',
        'currentUserPrices'
    ],
    additionalProperties: false
});
const AdjustableDoorCabinetShape = new AjvReflection('AdjustableDoorCabinetShape', {
    type: 'object',
    properties: {
        handing: Handing._meta.schema
    },
    additionalProperties: false,
    required: [
        'handing'
    ]
});
const BottomAdjustableDoorApplianceShape = new AjvReflection('BottomAdjustableDoorApplianceShape', {
    type: 'object',
    properties: {
        handing: Handing._meta.schema
    },
    additionalProperties: false,
    required: [
        'handing'
    ]
});
const RearPanelShape = new AjvReflection('RearPanelShape', {
    type: 'object',
    properties: {
        wallId: {
            type: 'string',
            pattern: '^[A-Z]\\w*-\\d+$'
        },
        width: {
            type: 'number',
            enum: [
                457.2,
                609.6,
                762,
                914.4,
                1066.8,
                1219.2,
                1371.6,
                1524,
                1676.4,
                1828.8,
                1981.2,
                2133.6,
                2286,
                2438.4
            ]
        }
    },
    additionalProperties: false,
    required: [
        'wallId',
        'width'
    ]
});
const BottomCabinetWithApplianceShape = new AjvReflection('BottomCabinetWithApplianceShape', {
    type: 'object',
    properties: {
        applianceId: {
            anyOf: [
                {
                    type: 'string',
                    pattern: '^[A-Z]\\w*-\\d+$'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    additionalProperties: false,
    required: [
        'applianceId'
    ]
});
const WallItemShape = new AjvReflection('WallItemShape', {
    type: 'object',
    properties: {
        wallId: {
            type: 'string',
            pattern: '^[A-Z]\\w*-\\d+$'
        },
        x: {
            type: 'number'
        }
    },
    additionalProperties: false,
    required: [
        'wallId',
        'x'
    ]
});
const Drawer33Door66Shape = new AjvReflection('Drawer33Door66Shape', {
    type: 'object',
    properties: {
        width: {
            type: 'number',
            enum: [
                457.2,
                609.6
            ]
        }
    },
    additionalProperties: false,
    required: [
        'width'
    ]
});
const FillerShape = new AjvReflection('FillerShape', {
    type: 'object',
    properties: {
        width: {
            type: 'number',
            enum: [
                25.4,
                31.75,
                38.1,
                44.45,
                50.8,
                57.15,
                63.5,
                69.85,
                76.2,
                82.55,
                88.9,
                95.25,
                101.6,
                107.95,
                114.3,
                120.65,
                127
            ]
        }
    },
    additionalProperties: false,
    required: [
        'width'
    ]
});
const FullDoorBaseShape = new AjvReflection('FullDoorBaseShape', {
    type: 'object',
    properties: {
        width: {
            type: 'number',
            enum: [
                304.8,
                457.2,
                609.6
            ]
        }
    },
    additionalProperties: false,
    required: [
        'width'
    ]
});
const GrillBaseShape = new AjvReflection('GrillBaseShape', {
    type: 'object',
    properties: {
        width: {
            type: 'number',
            enum: [
                914.4,
                1066.8,
                1219.2,
                1524
            ]
        },
        variant: GrillBaseVariant._meta.schema,
        warmingDrawerId: {
            anyOf: [
                {
                    type: 'string',
                    pattern: '^[A-Z]\\w*-\\d+$'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    additionalProperties: false,
    required: [
        'width',
        'variant',
        'warmingDrawerId'
    ]
});
const BurnerBaseW24Shape = new AjvReflection('BurnerBaseW24Shape', {
    type: 'object',
    properties: {
        variant: BurnerBaseW24Variant._meta.schema
    },
    additionalProperties: false,
    required: [
        'variant'
    ]
});
const LynxProfessionalOutdoorBeverageDispenserW24Shape = new AjvReflection('LynxProfessionalOutdoorBeverageDispenserW24Shape', {
    type: 'object',
    properties: {
        towerKitId: {
            anyOf: [
                {
                    type: 'string',
                    pattern: '^[A-Z]\\w*-\\d+$'
                },
                {
                    type: 'string',
                    pattern: '^[A-Z]\\w*-\\d+$'
                }
            ]
        }
    },
    additionalProperties: false,
    required: [
        'towerKitId'
    ]
});
const LynxProfessionalOutdoorIceMachineW15Shape = new AjvReflection('LynxProfessionalOutdoorIceMachineW15Shape', {
    type: 'object',
    properties: {
        drainPumpId: {
            type: 'string',
            pattern: '^[A-Z]\\w*-\\d+$'
        }
    },
    additionalProperties: false,
    required: [
        'drainPumpId'
    ]
});
const LynxGrillShape = new AjvReflection('LynxGrillShape', {
    type: 'object',
    properties: {
        variant: {
            type: 'string'
        }
    },
    additionalProperties: false,
    required: [
        'variant'
    ]
});
const LynxSinkShape = new AjvReflection('LynxSinkShape', {
    type: 'object',
    properties: {
        width: {
            type: 'number',
            enum: [
                457.2,
                609.6,
                762
            ]
        }
    },
    additionalProperties: false,
    required: [
        'width'
    ]
});
const ApplianceWithPowderCoatingShape = new AjvReflection('ApplianceWithPowderCoatingShape', {
    type: 'object',
    properties: {
        powderCoating: {
            type: 'boolean'
        }
    },
    additionalProperties: false,
    required: [
        'powderCoating'
    ]
});
const RoomShape = new AjvReflection('RoomShape', {
    type: 'object',
    properties: {
        shape: RoomShapeType._meta.schema,
        powderCoatType: PowderCoatType._meta.schema,
        cabinetColor: CabinetColor._meta.schema,
        fuelType: FuelType._meta.schema,
        stainlessSafeEnvironment: {
            type: 'boolean'
        }
    },
    additionalProperties: false,
    required: [
        'shape',
        'powderCoatType',
        'cabinetColor',
        'fuelType',
        'stainlessSafeEnvironment'
    ]
});
const LynxSinkBaseShape = new AjvReflection('LynxSinkBaseShape', {
    type: 'object',
    properties: {
        width: {
            type: 'number',
            enum: [
                609.6,
                762,
                914.4,
                1219.2
            ]
        }
    },
    additionalProperties: false,
    required: [
        'width'
    ]
});
const SinkBaseShape = new AjvReflection('SinkBaseShape', {
    type: 'object',
    properties: {
        width: {
            type: 'number',
            enum: [
                609.6,
                762,
                914.4,
                1219.2
            ]
        }
    },
    additionalProperties: false,
    required: [
        'width'
    ]
});
const ThreeDrawerBaseShape = new AjvReflection('ThreeDrawerBaseShape', {
    type: 'object',
    properties: {
        width: {
            type: 'number',
            enum: [
                457.2,
                609.6
            ]
        }
    },
    additionalProperties: false,
    required: [
        'width'
    ]
});
const TrashPulloutBaseShape = new AjvReflection('TrashPulloutBaseShape', {
    type: 'object',
    properties: {
        width: {
            type: 'number',
            enum: [
                457.2,
                609.6
            ]
        }
    },
    additionalProperties: false,
    required: [
        'width'
    ]
});
const WallShape = new AjvReflection('WallShape', {
    type: 'object',
    properties: {
        wallType: WallType._meta.schema,
        length: {
            type: 'number'
        },
        fullHeight: {
            type: 'boolean'
        },
        hidden: {
            type: 'boolean'
        }
    },
    additionalProperties: false,
    required: [
        'wallType',
        'length',
        'fullHeight',
        'hidden'
    ]
});
const CornerFillerShape = new AjvReflection('CornerFillerShape', {
    type: 'object',
    properties: {
        cornerFillerType: CornerFillerType._meta.schema
    },
    additionalProperties: false,
    required: [
        'cornerFillerType'
    ]
});
export const BurnerBaseW18 = new DomainEntityReflection('BurnerBaseW18', [
    AdjustableDoorCabinetShape._meta.schema,
    BottomCabinetWithApplianceShape._meta.schema,
    WallItemShape._meta.schema
]);
export const BurnerBaseW24 = new DomainEntityReflection('BurnerBaseW24', [
    BurnerBaseW24Shape._meta.schema,
    AdjustableDoorCabinetShape._meta.schema,
    BottomCabinetWithApplianceShape._meta.schema,
    WallItemShape._meta.schema
]);
export const CornerFiller = new DomainEntityReflection('CornerFiller', [
    CornerFillerShape._meta.schema
]);
export const Drawer33Door66 = new DomainEntityReflection('Drawer33Door66', [
    Drawer33Door66Shape._meta.schema,
    AdjustableDoorCabinetShape._meta.schema,
    WallItemShape._meta.schema
]);
export const EvoBaseW36 = new DomainEntityReflection('EvoBaseW36', [
    AdjustableDoorCabinetShape._meta.schema,
    BottomCabinetWithApplianceShape._meta.schema,
    WallItemShape._meta.schema
]);
export const EvoAffinity25G = new DomainEntityReflection('EvoAffinity25G', []);
export const EvoAffinity30G = new DomainEntityReflection('EvoAffinity30G', []);
export const EndPanel = new DomainEntityReflection('EndPanel', [
    WallItemShape._meta.schema
]);
export const Filler = new DomainEntityReflection('Filler', [
    FillerShape._meta.schema,
    WallItemShape._meta.schema
]);
export const FullDoorBase = new DomainEntityReflection('FullDoorBase', [
    FullDoorBaseShape._meta.schema,
    AdjustableDoorCabinetShape._meta.schema,
    BottomCabinetWithApplianceShape._meta.schema,
    WallItemShape._meta.schema
]);
export const GrillBase = new DomainEntityReflection('GrillBase', [
    GrillBaseShape._meta.schema,
    AdjustableDoorCabinetShape._meta.schema,
    BottomCabinetWithApplianceShape._meta.schema,
    WallItemShape._meta.schema
]);
export const KamadoGrillBase = new DomainEntityReflection('KamadoGrillBase', [
    AdjustableDoorCabinetShape._meta.schema,
    BottomCabinetWithApplianceShape._meta.schema,
    WallItemShape._meta.schema
]);
export const LynxAsadoGriddgle = new DomainEntityReflection('LynxAsadoGriddgle', [
    ApplianceWithPowderCoatingShape._meta.schema
]);
export const LynxKamadoGrill = new DomainEntityReflection('LynxKamadoGrill', []);
export const LynxNapoliPizzaOven = new DomainEntityReflection('LynxNapoliPizzaOven', [
    WallItemShape._meta.schema
]);
export const LynxProfessionalCocktailStation = new DomainEntityReflection('LynxProfessionalCocktailStation', []);
export const LynxProfessionalGrillW30 = new DomainEntityReflection('LynxProfessionalGrillW30', [
    LynxGrillShape._meta.schema,
    ApplianceWithPowderCoatingShape._meta.schema
]);
export const LynxProfessionalGrillW36 = new DomainEntityReflection('LynxProfessionalGrillW36', [
    LynxGrillShape._meta.schema,
    ApplianceWithPowderCoatingShape._meta.schema
]);
export const LynxProfessionalGrillW42 = new DomainEntityReflection('LynxProfessionalGrillW42', [
    LynxGrillShape._meta.schema,
    ApplianceWithPowderCoatingShape._meta.schema
]);
export const LynxProfessionalGrillW54 = new DomainEntityReflection('LynxProfessionalGrillW54', [
    LynxGrillShape._meta.schema,
    ApplianceWithPowderCoatingShape._meta.schema
]);
export const LynxProfessionalSingleBurner = new DomainEntityReflection('LynxProfessionalSingleBurner', [
    ApplianceWithPowderCoatingShape._meta.schema
]);
export const LynxProfessionalDoubleBurner = new DomainEntityReflection('LynxProfessionalDoubleBurner', [
    ApplianceWithPowderCoatingShape._meta.schema
]);
export const LynxProfessionalPowerBurner = new DomainEntityReflection('LynxProfessionalPowerBurner', [
    ApplianceWithPowderCoatingShape._meta.schema
]);
export const LynxProfessionalOutdoorBeverageDispenserW24 = new DomainEntityReflection('LynxProfessionalOutdoorBeverageDispenserW24', [
    LynxProfessionalOutdoorBeverageDispenserW24Shape._meta.schema,
    BottomAdjustableDoorApplianceShape._meta.schema,
    WallItemShape._meta.schema
]);
export const LynxProfessionalRefrigeratorFreezerComboW24 = new DomainEntityReflection('LynxProfessionalRefrigeratorFreezerComboW24', [
    BottomAdjustableDoorApplianceShape._meta.schema,
    WallItemShape._meta.schema
]);
export const LynxProfessionalOutdoorRefrigeratorW24 = new DomainEntityReflection('LynxProfessionalOutdoorRefrigeratorW24', [
    BottomAdjustableDoorApplianceShape._meta.schema,
    WallItemShape._meta.schema
]);
export const LynxProfessionalOutdoorRefrigeratorWithGlassDoorW24 = new DomainEntityReflection('LynxProfessionalOutdoorRefrigeratorWithGlassDoorW24', [
    BottomAdjustableDoorApplianceShape._meta.schema,
    WallItemShape._meta.schema
]);
export const LynxProfessionalRefrigeratorW15 = new DomainEntityReflection('LynxProfessionalRefrigeratorW15', [
    BottomAdjustableDoorApplianceShape._meta.schema,
    WallItemShape._meta.schema
]);
export const LynxProfessionalWineCellarW15 = new DomainEntityReflection('LynxProfessionalWineCellarW15', [
    BottomAdjustableDoorApplianceShape._meta.schema,
    WallItemShape._meta.schema
]);
export const LynxProfessionalTwoDrawerRefrigeratorW24 = new DomainEntityReflection('LynxProfessionalTwoDrawerRefrigeratorW24', [
    WallItemShape._meta.schema
]);
export const LynxProfessionalOutdoorIceMachineW15 = new DomainEntityReflection('LynxProfessionalOutdoorIceMachineW15', [
    LynxProfessionalOutdoorIceMachineW15Shape._meta.schema,
    BottomAdjustableDoorApplianceShape._meta.schema,
    WallItemShape._meta.schema
]);
export const LynxProfessionalOutdoorIceMachineDrainPump = new DomainEntityReflection('LynxProfessionalOutdoorIceMachineDrainPump', []);
export const LynxProfessionalSingleTapTowerKit = new DomainEntityReflection('LynxProfessionalSingleTapTowerKit', []);
export const LynxProfessionalDoubleTapTowerKit = new DomainEntityReflection('LynxProfessionalDoubleTapTowerKit', []);
export const LynxSedonaGrillW30 = new DomainEntityReflection('LynxSedonaGrillW30', [
    LynxGrillShape._meta.schema
]);
export const LynxSedonaGrillW36 = new DomainEntityReflection('LynxSedonaGrillW36', [
    LynxGrillShape._meta.schema
]);
export const LynxSedonaGrillW42 = new DomainEntityReflection('LynxSedonaGrillW42', [
    LynxGrillShape._meta.schema
]);
export const LynxSedonaSingleBurner = new DomainEntityReflection('LynxSedonaSingleBurner', [
    ApplianceWithPowderCoatingShape._meta.schema
]);
export const LynxSedonaDoubleBurner = new DomainEntityReflection('LynxSedonaDoubleBurner', [
    ApplianceWithPowderCoatingShape._meta.schema
]);
export const LynxSedonaHoodW36 = new DomainEntityReflection('LynxSedonaHoodW36', [
    WallItemShape._meta.schema
]);
export const LynxSedonaHoodW42 = new DomainEntityReflection('LynxSedonaHoodW42', [
    WallItemShape._meta.schema
]);
export const LynxSedonaHoodW48 = new DomainEntityReflection('LynxSedonaHoodW48', [
    WallItemShape._meta.schema
]);
export const LynxSinkW18 = new DomainEntityReflection('LynxSinkW18', [
    LynxSinkShape._meta.schema
]);
export const LynxSinkW24 = new DomainEntityReflection('LynxSinkW24', [
    LynxSinkShape._meta.schema
]);
export const LynxSinkW30 = new DomainEntityReflection('LynxSinkW30', [
    LynxSinkShape._meta.schema
]);
export const LynxSinkBase = new DomainEntityReflection('LynxSinkBase', [
    LynxSinkBaseShape._meta.schema,
    AdjustableDoorCabinetShape._meta.schema,
    BottomCabinetWithApplianceShape._meta.schema,
    WallItemShape._meta.schema
]);
export const LynxWarmingDrawer = new DomainEntityReflection('LynxWarmingDrawer', [
    ApplianceWithPowderCoatingShape._meta.schema
]);
export const Room = new DomainEntityReflection('Room', [
    RoomShape._meta.schema
]);
export const RearPanel = new DomainEntityReflection('RearPanel', [
    RearPanelShape._meta.schema
]);
export const SinkBase = new DomainEntityReflection('SinkBase', [
    SinkBaseShape._meta.schema,
    AdjustableDoorCabinetShape._meta.schema,
    BottomCabinetWithApplianceShape._meta.schema,
    WallItemShape._meta.schema
]);
export const ThreeDrawerBase = new DomainEntityReflection('ThreeDrawerBase', [
    ThreeDrawerBaseShape._meta.schema,
    WallItemShape._meta.schema
]);
export const TrashPulloutBase = new DomainEntityReflection('TrashPulloutBase', [
    TrashPulloutBaseShape._meta.schema,
    AdjustableDoorCabinetShape._meta.schema,
    WallItemShape._meta.schema
]);
export const Wall = new DomainEntityReflection('Wall', [
    WallShape._meta.schema
]);
export const AnyDomainEntity = new RawAliasReflection('AnyDomainEntity', [
    BurnerBaseW18,
    BurnerBaseW24,
    CornerFiller,
    Drawer33Door66,
    EvoBaseW36,
    EvoAffinity25G,
    EvoAffinity30G,
    EndPanel,
    Filler,
    FullDoorBase,
    GrillBase,
    KamadoGrillBase,
    LynxAsadoGriddgle,
    LynxKamadoGrill,
    LynxNapoliPizzaOven,
    LynxProfessionalCocktailStation,
    LynxProfessionalGrillW30,
    LynxProfessionalGrillW36,
    LynxProfessionalGrillW42,
    LynxProfessionalGrillW54,
    LynxProfessionalSingleBurner,
    LynxProfessionalDoubleBurner,
    LynxProfessionalPowerBurner,
    LynxProfessionalOutdoorBeverageDispenserW24,
    LynxProfessionalRefrigeratorFreezerComboW24,
    LynxProfessionalOutdoorRefrigeratorW24,
    LynxProfessionalOutdoorRefrigeratorWithGlassDoorW24,
    LynxProfessionalRefrigeratorW15,
    LynxProfessionalWineCellarW15,
    LynxProfessionalTwoDrawerRefrigeratorW24,
    LynxProfessionalOutdoorIceMachineW15,
    LynxProfessionalOutdoorIceMachineDrainPump,
    LynxProfessionalSingleTapTowerKit,
    LynxProfessionalDoubleTapTowerKit,
    LynxSedonaGrillW30,
    LynxSedonaGrillW36,
    LynxSedonaGrillW42,
    LynxSedonaSingleBurner,
    LynxSedonaDoubleBurner,
    LynxSedonaHoodW36,
    LynxSedonaHoodW42,
    LynxSedonaHoodW48,
    LynxSinkW18,
    LynxSinkW24,
    LynxSinkW30,
    LynxSinkBase,
    LynxWarmingDrawer,
    Room,
    RearPanel,
    SinkBase,
    ThreeDrawerBase,
    TrashPulloutBase,
    Wall
]);
export const RootEntity = new RawAliasReflection('RootEntity', [
    Room
]);
export const StaticEntity = new RawAliasReflection('StaticEntity', [
    Room,
    Wall,
    CornerFiller
]);
export const BurnerBase = new RawAliasReflection('BurnerBase', [
    BurnerBaseW18,
    BurnerBaseW24
]);
export const AdjustableDoorCabinet = new RawAliasReflection('AdjustableDoorCabinet', [
    ...BurnerBase.reflections,
    Drawer33Door66,
    EvoBaseW36,
    FullDoorBase,
    GrillBase,
    KamadoGrillBase,
    LynxSinkBase,
    SinkBase,
    TrashPulloutBase
]);
export const TopAppliance = new RawAliasReflection('TopAppliance', [
    LynxSedonaHoodW36,
    LynxSedonaHoodW42,
    LynxSedonaHoodW48
]);
export const LynxSink = new RawAliasReflection('LynxSink', [
    LynxSinkW18,
    LynxSinkW24,
    LynxSinkW30
]);
export const BottomAdjustableDoorAppliance = new RawAliasReflection('BottomAdjustableDoorAppliance', [
    LynxProfessionalOutdoorBeverageDispenserW24,
    LynxProfessionalRefrigeratorFreezerComboW24,
    LynxProfessionalOutdoorRefrigeratorW24,
    LynxProfessionalOutdoorRefrigeratorWithGlassDoorW24,
    LynxProfessionalRefrigeratorW15,
    LynxProfessionalWineCellarW15,
    LynxProfessionalOutdoorIceMachineW15
]);
export const BottomNonAdjustableDoorAppliance = new RawAliasReflection('BottomNonAdjustableDoorAppliance', [
    LynxProfessionalTwoDrawerRefrigeratorW24,
    LynxProfessionalSingleTapTowerKit,
    LynxProfessionalDoubleTapTowerKit,
    LynxProfessionalOutdoorIceMachineDrainPump,
    LynxWarmingDrawer
]);
export const BottomCabinetAppliance = new RawAliasReflection('BottomCabinetAppliance', [
    LynxAsadoGriddgle,
    LynxKamadoGrill,
    LynxProfessionalGrillW30,
    LynxProfessionalGrillW36,
    LynxProfessionalGrillW42,
    LynxProfessionalGrillW54,
    LynxSedonaGrillW30,
    LynxSedonaGrillW36,
    LynxSedonaGrillW42,
    LynxProfessionalCocktailStation,
    LynxProfessionalSingleBurner,
    LynxProfessionalDoubleBurner,
    LynxProfessionalPowerBurner,
    LynxSedonaSingleBurner,
    LynxSedonaDoubleBurner,
    LynxSinkW18,
    LynxSinkW24,
    LynxSinkW30,
    EvoAffinity25G,
    EvoAffinity30G
]);
export const CountertopAppliance = new RawAliasReflection('CountertopAppliance', [
    LynxNapoliPizzaOven
]);
export const CountertopWallItem = new RawAliasReflection('CountertopWallItem', [
    ...CountertopAppliance.reflections
]);
export const BottomWallAppliance = new RawAliasReflection('BottomWallAppliance', [
    LynxProfessionalOutdoorBeverageDispenserW24,
    LynxProfessionalRefrigeratorFreezerComboW24,
    LynxProfessionalOutdoorRefrigeratorW24,
    LynxProfessionalOutdoorRefrigeratorWithGlassDoorW24,
    LynxProfessionalRefrigeratorW15,
    LynxProfessionalWineCellarW15,
    LynxProfessionalTwoDrawerRefrigeratorW24,
    LynxProfessionalOutdoorIceMachineW15
]);
export const BottomAppliance = new RawAliasReflection('BottomAppliance', [
    ...BottomCabinetAppliance.reflections,
    ...BottomWallAppliance.reflections,
    LynxProfessionalSingleTapTowerKit,
    LynxProfessionalDoubleTapTowerKit,
    LynxProfessionalOutdoorIceMachineDrainPump,
    LynxWarmingDrawer
]);
export const SwatchPowderCoatableRoomItem = new RawAliasReflection('SwatchPowderCoatableRoomItem', [
    ...BurnerBase.reflections,
    CornerFiller,
    Drawer33Door66,
    EvoBaseW36,
    EndPanel,
    Filler,
    FullDoorBase,
    GrillBase,
    KamadoGrillBase,
    LynxSinkBase,
    RearPanel,
    SinkBase,
    ThreeDrawerBase,
    TrashPulloutBase
]);
export const PulsePowderCoatableRoomItem = new RawAliasReflection('PulsePowderCoatableRoomItem', [
    ...BurnerBase.reflections,
    Drawer33Door66,
    EvoBaseW36,
    FullDoorBase,
    GrillBase,
    KamadoGrillBase,
    LynxSinkBase,
    SinkBase,
    ThreeDrawerBase,
    TrashPulloutBase
]);
export const BottomCabinet = new RawAliasReflection('BottomCabinet', [
    ...BurnerBase.reflections,
    Drawer33Door66,
    EvoBaseW36,
    FullDoorBase,
    GrillBase,
    KamadoGrillBase,
    LynxSinkBase,
    SinkBase,
    ThreeDrawerBase,
    TrashPulloutBase
]);
export const BottomCabinetWithAppliance = new RawAliasReflection('BottomCabinetWithAppliance', [
    ...BurnerBase.reflections,
    EvoBaseW36,
    FullDoorBase,
    GrillBase,
    KamadoGrillBase,
    LynxSinkBase,
    SinkBase
]);
export const BottomCabinetWithoutAppliance = new RawAliasReflection('BottomCabinetWithoutAppliance', [
    Drawer33Door66,
    ThreeDrawerBase,
    TrashPulloutBase
]);
export const BottomCabinetWithDefaultDetail = new RawAliasReflection('BottomCabinetWithDefaultDetail', [
    BurnerBaseW18,
    Drawer33Door66,
    EvoBaseW36,
    FullDoorBase,
    KamadoGrillBase,
    LynxSinkBase,
    SinkBase,
    ThreeDrawerBase,
    TrashPulloutBase
]);
export const BottomPart = new RawAliasReflection('BottomPart', [
    EndPanel,
    Filler,
    RearPanel
]);
export const BottomWallItemWithDefaultCountertop = new RawAliasReflection('BottomWallItemWithDefaultCountertop', [
    Drawer33Door66,
    EndPanel,
    Filler,
    LynxProfessionalOutdoorBeverageDispenserW24,
    LynxProfessionalRefrigeratorFreezerComboW24,
    LynxProfessionalOutdoorRefrigeratorW24,
    LynxProfessionalOutdoorRefrigeratorWithGlassDoorW24,
    LynxProfessionalRefrigeratorW15,
    LynxProfessionalWineCellarW15,
    LynxProfessionalTwoDrawerRefrigeratorW24,
    LynxProfessionalOutdoorIceMachineW15,
    ThreeDrawerBase,
    TrashPulloutBase
]);
export const BottomWallItemWithCustomCountertop = new RawAliasReflection('BottomWallItemWithCustomCountertop', [
    ...BurnerBase.reflections,
    EvoBaseW36,
    FullDoorBase,
    GrillBase,
    KamadoGrillBase,
    LynxSinkBase,
    SinkBase
]);
export const BottomWallItemWithDefaultToeKick = new RawAliasReflection('BottomWallItemWithDefaultToeKick', [
    ...BurnerBase.reflections,
    Drawer33Door66,
    EvoBaseW36,
    Filler,
    FullDoorBase,
    GrillBase,
    KamadoGrillBase,
    LynxSinkBase,
    SinkBase,
    ThreeDrawerBase,
    TrashPulloutBase
]);
export const BottomWallItemWithBackPanel = new RawAliasReflection('BottomWallItemWithBackPanel', [
    ...BottomCabinet.reflections,
    ...BottomWallAppliance.reflections,
    Filler
]);
export const RoomItem = new RawAliasReflection('RoomItem', [
    ...BottomAppliance.reflections,
    ...BottomCabinet.reflections,
    ...BottomPart.reflections,
    ...TopAppliance.reflections,
    ...CountertopWallItem.reflections
]);
export const RoomItemWithDefaultPrice = new RawAliasReflection('RoomItemWithDefaultPrice', [
    ...BurnerBase.reflections,
    Drawer33Door66,
    EvoBaseW36,
    EvoAffinity25G,
    EvoAffinity30G,
    EndPanel,
    Filler,
    FullDoorBase,
    GrillBase,
    KamadoGrillBase,
    LynxKamadoGrill,
    LynxNapoliPizzaOven,
    LynxProfessionalCocktailStation,
    LynxProfessionalRefrigeratorFreezerComboW24,
    LynxProfessionalOutdoorRefrigeratorW24,
    LynxProfessionalOutdoorRefrigeratorWithGlassDoorW24,
    LynxProfessionalRefrigeratorW15,
    LynxProfessionalWineCellarW15,
    LynxProfessionalOutdoorIceMachineW15,
    LynxProfessionalOutdoorBeverageDispenserW24,
    LynxProfessionalTwoDrawerRefrigeratorW24,
    LynxProfessionalOutdoorIceMachineDrainPump,
    LynxProfessionalSingleTapTowerKit,
    LynxProfessionalDoubleTapTowerKit,
    LynxSedonaHoodW36,
    LynxSedonaHoodW42,
    LynxSedonaHoodW48,
    LynxSinkW18,
    LynxSinkW24,
    LynxSinkW30,
    LynxSinkBase,
    RearPanel,
    SinkBase,
    ThreeDrawerBase,
    TrashPulloutBase,
    LynxSedonaGrillW30,
    LynxSedonaGrillW36,
    LynxSedonaGrillW42
]);
export const RoomItemWithDefaultSummary = new RawAliasReflection('RoomItemWithDefaultSummary', [
    ...BurnerBase.reflections,
    Drawer33Door66,
    EvoBaseW36,
    EvoAffinity25G,
    EvoAffinity30G,
    EndPanel,
    Filler,
    FullDoorBase,
    GrillBase,
    KamadoGrillBase,
    LynxAsadoGriddgle,
    LynxKamadoGrill,
    LynxNapoliPizzaOven,
    LynxProfessionalCocktailStation,
    LynxProfessionalGrillW30,
    LynxProfessionalGrillW36,
    LynxProfessionalGrillW42,
    LynxProfessionalGrillW54,
    LynxProfessionalSingleBurner,
    LynxProfessionalDoubleBurner,
    LynxProfessionalPowerBurner,
    LynxProfessionalRefrigeratorFreezerComboW24,
    LynxProfessionalOutdoorRefrigeratorW24,
    LynxProfessionalOutdoorRefrigeratorWithGlassDoorW24,
    LynxProfessionalRefrigeratorW15,
    LynxProfessionalWineCellarW15,
    LynxProfessionalTwoDrawerRefrigeratorW24,
    LynxProfessionalOutdoorIceMachineDrainPump,
    LynxProfessionalSingleTapTowerKit,
    LynxProfessionalDoubleTapTowerKit,
    LynxSedonaGrillW30,
    LynxSedonaGrillW36,
    LynxSedonaGrillW42,
    LynxSedonaSingleBurner,
    LynxSedonaDoubleBurner,
    LynxSedonaHoodW36,
    LynxSedonaHoodW42,
    LynxSedonaHoodW48,
    LynxWarmingDrawer,
    LynxSinkW18,
    LynxSinkW24,
    LynxSinkW30,
    LynxSinkBase,
    RearPanel,
    SinkBase,
    ThreeDrawerBase,
    TrashPulloutBase
]);
export const BottomWallItem = new RawAliasReflection('BottomWallItem', [
    ...BottomCabinet.reflections,
    ...BottomWallAppliance.reflections,
    Filler,
    EndPanel
]);
export const TopWallItem = new RawAliasReflection('TopWallItem', [
    ...TopAppliance.reflections
]);
export const WallItem = new RawAliasReflection('WallItem', [
    ...BottomWallItem.reflections,
    ...TopWallItem.reflections,
    ...CountertopWallItem.reflections
]);
export const LynxProfessionalGrill = new RawAliasReflection('LynxProfessionalGrill', [
    LynxProfessionalGrillW30,
    LynxProfessionalGrillW36,
    LynxProfessionalGrillW42,
    LynxProfessionalGrillW54
]);
export const LynxSedonaGrill = new RawAliasReflection('LynxSedonaGrill', [
    LynxSedonaGrillW30,
    LynxSedonaGrillW36,
    LynxSedonaGrillW42
]);
export const LynxGrill = new RawAliasReflection('LynxGrill', [
    ...LynxProfessionalGrill.reflections,
    ...LynxSedonaGrill.reflections
]);
export const LynxProfessionalBurner = new RawAliasReflection('LynxProfessionalBurner', [
    LynxProfessionalSingleBurner,
    LynxProfessionalDoubleBurner,
    LynxProfessionalPowerBurner
]);
export const LynxSedonaBurner = new RawAliasReflection('LynxSedonaBurner', [
    LynxSedonaSingleBurner,
    LynxSedonaDoubleBurner
]);
export const LynxBurner = new RawAliasReflection('LynxBurner', [
    ...LynxProfessionalBurner.reflections,
    ...LynxSedonaBurner.reflections
]);
export const LynxProfessionalTapTowerKit = new RawAliasReflection('LynxProfessionalTapTowerKit', [
    LynxProfessionalSingleTapTowerKit,
    LynxProfessionalDoubleTapTowerKit
]);
export const ApplianceWithPowderCoating = new RawAliasReflection('ApplianceWithPowderCoating', [
    ...LynxProfessionalGrill.reflections,
    LynxAsadoGriddgle,
    ...LynxBurner.reflections,
    LynxWarmingDrawer
]);
export const ResizableWallItem = new RawAliasReflection('ResizableWallItem', [
    Drawer33Door66,
    Filler,
    FullDoorBase,
    GrillBase,
    LynxSinkBase,
    SinkBase,
    ThreeDrawerBase,
    TrashPulloutBase
]);
export const LynxSedonaHood = new RawAliasReflection('LynxSedonaHood', [
    LynxSedonaHoodW36,
    LynxSedonaHoodW42,
    LynxSedonaHoodW48
]);
export const Hood = new RawAliasReflection('Hood', [
    ...LynxSedonaHood.reflections
]);
export const Appliance = new RawAliasReflection('Appliance', [
    ...TopAppliance.reflections,
    ...BottomAppliance.reflections,
    ...CountertopAppliance.reflections
]);
export const aliases = {
    AnyDomainEntity: AnyDomainEntity.types,
    RootEntity: RootEntity.types,
    StaticEntity: StaticEntity.types,
    BurnerBase: BurnerBase.types,
    AdjustableDoorCabinet: AdjustableDoorCabinet.types,
    TopAppliance: TopAppliance.types,
    LynxSink: LynxSink.types,
    BottomAdjustableDoorAppliance: BottomAdjustableDoorAppliance.types,
    BottomNonAdjustableDoorAppliance: BottomNonAdjustableDoorAppliance.types,
    BottomCabinetAppliance: BottomCabinetAppliance.types,
    CountertopAppliance: CountertopAppliance.types,
    CountertopWallItem: CountertopWallItem.types,
    BottomWallAppliance: BottomWallAppliance.types,
    BottomAppliance: BottomAppliance.types,
    SwatchPowderCoatableRoomItem: SwatchPowderCoatableRoomItem.types,
    PulsePowderCoatableRoomItem: PulsePowderCoatableRoomItem.types,
    BottomCabinet: BottomCabinet.types,
    BottomCabinetWithAppliance: BottomCabinetWithAppliance.types,
    BottomCabinetWithoutAppliance: BottomCabinetWithoutAppliance.types,
    BottomCabinetWithDefaultDetail: BottomCabinetWithDefaultDetail.types,
    BottomPart: BottomPart.types,
    BottomWallItemWithDefaultCountertop: BottomWallItemWithDefaultCountertop.types,
    BottomWallItemWithCustomCountertop: BottomWallItemWithCustomCountertop.types,
    BottomWallItemWithDefaultToeKick: BottomWallItemWithDefaultToeKick.types,
    BottomWallItemWithBackPanel: BottomWallItemWithBackPanel.types,
    RoomItem: RoomItem.types,
    RoomItemWithDefaultPrice: RoomItemWithDefaultPrice.types,
    RoomItemWithDefaultSummary: RoomItemWithDefaultSummary.types,
    BottomWallItem: BottomWallItem.types,
    TopWallItem: TopWallItem.types,
    WallItem: WallItem.types,
    LynxProfessionalGrill: LynxProfessionalGrill.types,
    LynxSedonaGrill: LynxSedonaGrill.types,
    LynxGrill: LynxGrill.types,
    LynxProfessionalBurner: LynxProfessionalBurner.types,
    LynxSedonaBurner: LynxSedonaBurner.types,
    LynxBurner: LynxBurner.types,
    LynxProfessionalTapTowerKit: LynxProfessionalTapTowerKit.types,
    ApplianceWithPowderCoating: ApplianceWithPowderCoating.types,
    ResizableWallItem: ResizableWallItem.types,
    LynxSedonaHood: LynxSedonaHood.types,
    Hood: Hood.types,
    Appliance: Appliance.types
};
export const entities = {
    BurnerBaseW18,
    BurnerBaseW24,
    CornerFiller,
    Drawer33Door66,
    EvoBaseW36,
    EvoAffinity25G,
    EvoAffinity30G,
    EndPanel,
    Filler,
    FullDoorBase,
    GrillBase,
    KamadoGrillBase,
    LynxAsadoGriddgle,
    LynxKamadoGrill,
    LynxNapoliPizzaOven,
    LynxProfessionalCocktailStation,
    LynxProfessionalGrillW30,
    LynxProfessionalGrillW36,
    LynxProfessionalGrillW42,
    LynxProfessionalGrillW54,
    LynxProfessionalSingleBurner,
    LynxProfessionalDoubleBurner,
    LynxProfessionalPowerBurner,
    LynxProfessionalOutdoorBeverageDispenserW24,
    LynxProfessionalRefrigeratorFreezerComboW24,
    LynxProfessionalOutdoorRefrigeratorW24,
    LynxProfessionalOutdoorRefrigeratorWithGlassDoorW24,
    LynxProfessionalRefrigeratorW15,
    LynxProfessionalWineCellarW15,
    LynxProfessionalTwoDrawerRefrigeratorW24,
    LynxProfessionalOutdoorIceMachineW15,
    LynxProfessionalOutdoorIceMachineDrainPump,
    LynxProfessionalSingleTapTowerKit,
    LynxProfessionalDoubleTapTowerKit,
    LynxSedonaGrillW30,
    LynxSedonaGrillW36,
    LynxSedonaGrillW42,
    LynxSedonaSingleBurner,
    LynxSedonaDoubleBurner,
    LynxSedonaHoodW36,
    LynxSedonaHoodW42,
    LynxSedonaHoodW48,
    LynxSinkW18,
    LynxSinkW24,
    LynxSinkW30,
    LynxSinkBase,
    LynxWarmingDrawer,
    Room,
    RearPanel,
    SinkBase,
    ThreeDrawerBase,
    TrashPulloutBase,
    Wall
};

//# sourceMappingURL=v11.js.map